import type { BaseInventoryModel } from '@/types/BookingGameMetadataModel';
import { helpers } from '@vuelidate/validators';

export const inventorySoldOutValidator = (inventory?: BaseInventoryModel) => {
	return (inventoryId: number | null) => {
		return !helpers.req(inventoryId) || !inventory || !inventory.IsSoldOut;
	};
};

export const inventoryStockValidator = (inventory?: BaseInventoryModel, quantity?: () => number) => {
	return (inventoryId: number | null) => {
		const q = quantity ? quantity() : 0;
		return !helpers.req(inventoryId) || !inventory || inventory.StockAvailable >= q;
	};
};

export const createInventorySoldOutValidator = (inventoryList: BaseInventoryModel[]) => {
	return (inventoryId: number | null) => {
		const inventory = inventoryList.find(x => x.InventoryId == inventoryId);
		return inventorySoldOutValidator(inventory)(inventoryId);
	};
};

export const createInventoryStockValidator = (inventoryList: BaseInventoryModel[], quantity: () => number) => {
	return (inventoryId: number | null) => {
		const inventory = inventoryList.find(x => x.InventoryId == inventoryId);
		return inventoryStockValidator(inventory, quantity)(inventoryId);
	};
};
